import { render, staticRenderFns } from "./describe.vue?vue&type=template&id=f90f8a3a&scoped=true&"
import script from "./describe.vue?vue&type=script&lang=js&"
export * from "./describe.vue?vue&type=script&lang=js&"
import style0 from "./describe.vue?vue&type=style&index=0&id=f90f8a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90f8a3a",
  null
  
)

export default component.exports